<template>
  <div class="card-body">
    <div class="mb-3">
      <argon-input
        type="text"
        placeholder="Recovery Code"
        name="recoveryCode"
        size="lg"
        v-model:value.sync="recoveryCode"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="email"
        placeholder="Email"
        name="email"
        size="lg"
        v-model:value.sync="email"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Password"
        name="password"
        size="lg"
        v-model:value.sync="password"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Confirm Password"
        name="confirmPassword"
        size="lg"
        v-model:value.sync="confirmPassword"
      />
    </div>
    <div class="text-center">
      <argon-button
        class="mt-4"
        variant="gradient"
        color="success"
        fullWidth
        size="lg"
        @click="Continue"
        :isLoading="continueButtonClicked"
        :isLoadingText="'Continue...'"
        >Continue</argon-button
      >
    </div>
  </div>
</template>

<script>
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { Validator } from "@/customFunctions/Validator.js";
import { Toaster } from "@/customFunctions/Utils.js";
import { SendPOSTUserAPI } from "@/customFunctions/Api.js";
import { mapGetters } from "vuex";

export default {
  name: "inputs-container",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      email: "",
      recoveryCode: "",
      password: "",
      confirmPassword: "",
      continueButtonClicked: false,
    };
  },

  computed: {
    ...mapGetters(["getUserEmail", "getAuth0PasswordPolicyEnabled"]),
  },

  mounted() {
    if (this.getUserEmail) {
      this.email = this.getUserEmail;
    }
    if (
      this.getAuth0PasswordPolicyEnabled &&
      sessionStorage.getItem("evolvePasswordPolicyRedirect")
    ) {
      sessionStorage.removeItem("evolvePasswordPolicyRedirect");
      this.$nextTick(() => {
        this.Toaster(
          "You were redirected here because your password must meet security requirements: at least 8 characters, uppercase and lowercase letters, a number, and a special character. Use the code from your email, then set a new password.",
          "Why you are here",
          "warning"
        );
      });
    }
  },

  methods: {
    async Continue() {
      this.continueButtonClicked = true;
      if (!this.Validate()) {
        this.continueButtonClicked = false;
        return;
      }

      try {
        const userApiResponse = await SendPOSTUserAPI(
          "users/confirm-reset-password",
          null,
          {
            username: this.email,
            confirmationCode: this.recoveryCode,
            password: this.password,
          }
        );
        
        const responseJson = await userApiResponse;
        const isOk = responseJson.statusCode === 200;

        if (isOk) this.$router.push({ path: "signin" });
        if (responseJson.message)
          this.Toaster(responseJson.message, "Error", "danger");
      } catch (e) {
        console.log(e, "Continue exception");
      }

      this.continueButtonClicked = false;
    },
    Validate() {
      Validator.validateEmail(this.email);
      Validator.validatePassword(this.password);
      if (this.getAuth0PasswordPolicyEnabled) {
        Validator.validateStrongPassword(this.password);
      }
      Validator.validateConfirmPassword(this.password, this.confirmPassword);
      Validator.validateLength(this.recoveryCode, 6, "Recovery Code");

      return !Validator.validateIfHasError(this.Toaster);
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
